import { FETCH_ERROR } from './actionTypes'
import { FetchError } from './errorTypes'

export const fetchError = (message: string): FetchError => {
  return {
    type: FETCH_ERROR,
    payload: message,
  }
}
